import { render, staticRenderFns } from "./TicketGive.vue?vue&type=template&id=656ccf9b&scoped=true"
import script from "./TicketGive.vue?vue&type=script&lang=js"
export * from "./TicketGive.vue?vue&type=script&lang=js"
import style0 from "./TicketGive.vue?vue&type=style&index=0&id=656ccf9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ccf9b",
  null
  
)

export default component.exports